<template>
    <div :class="configureClass()">
      <small-loader v-if="downloadLoading"></small-loader>
  
      <div style="width:100%;height:50px;text-align: center;">
        <div style="width:100%;float:left;text-align:center;padding-top:10px;">
          <CButton size="sm" @click="close()" color="danger">Close</CButton>
        </div>
      </div>
      
      <div v-show="!downloadLoading && !notExist" id="adobe-dc-view"></div>
  
      <div style="width:100%;height:calc(100% - 50px);text-align:center;background-color:#fff;" v-if="notExist">
        <!-- No PDF message -->
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    name: "AdobePdfViewer",
    props: ['order_group', 'pdf_type', 'allowEdit', 'otherClass', 'repView', 'oldOrderItem', 'oldOrder'],
  
    data() {
      return {
        notExist: false,
        downloadLoading: true,
      }
    },
  
    mounted() {
      // Load Adobe Viewer SDK script if not already loaded
      if (!document.getElementById('adobeScript')) {
        let adobe = document.createElement('script')
        adobe.setAttribute('id', 'adobeScript')
        adobe.setAttribute('src', 'https://documentservices.adobe.com/view-sdk/viewer.js')
        document.head.appendChild(adobe)
      }
  
      // Fetch and load PDF
      if (this.order_group || this.oldOrder) {
        this.getPdf();
      } else {
        // Handle case when order_group is not available
      }
    },
  
    methods: {
      close() {
        this.$emit('closed')
      },
  
      configureClass() {
        return this.otherClass ? this.otherClass : 'pdfWrapper';
      },
  
      changeCsrStatus() {
        const postData = { form: this.order_group };
        axios.post(this.$apiAdress + '/api/orders/changeCsrStatus?token=' + localStorage.getItem('api_token'), postData)
          .then(response => {
            console.log(response);
          });
      },
  
      getPdf() {
    if (!this.oldOrder) {
      if (!this.order_group) {
        // Handle case when order_group is not available
        return;
      }
  
      const postData = {
        order_group_id: this.order_group.order_group_id,
        type: this.pdf_type
      };
  
      axios.post(this.$apiAdress + '/api/orders/downloadPdf?token=' + localStorage.getItem('api_token'), postData)
        .then(response => {
          this.downloadLoading = false;
          if (response.data !== 'not-exist') {
            this.tryLoad(response.data);
          } else {
            this.notExist = true;
          }
        })
        .catch(error => {
          console.error('Error fetching PDF:', error);
          this.showError('It looks like the PDF for this order might not exist. If you think it should, please contact your CSR and let them know of this issue.'); // Display error message
        });
    } else {
        const postData = {
            logNumber: this.oldOrderItem.log_number
        }
        console.log(postData)
      axios.post(this.$apiAdress + '/api/orderHistory/fetch-pdf?token=' + localStorage.getItem('api_token'), postData)
        .then(response => {
          this.downloadLoading = false;
          console.log(response.data['pdfData']);
          this.tryLoad(response.data['pdfData']);
        })
        .catch(error => {
          console.error('Error fetching PDF from FTP:', error);
          this.showError('It looks like the PDF for this order might not exist. If you think it should, please contact your CSR and let them know of this issue.'); // Display error message
        });
    }
  },
  
  showError(message) {
    // You can customize this method to display error messages in your application UI
    alert(message); // Basic alert for demonstration purposes
  }
  ,
  
  tryLoad(pdfData) {
      const clientID = process.env.VUE_APP_ADOBE_ID;
      const that = this;
  
      const viewOptions = {
          embedMode: "FULL_WINDOW",
          defaultViewMode: "FIT_WIDTH",
          showAnnotationTools: !this.repView,
      };
  
      const adobeDCView = new AdobeDC.View({
          clientId: clientID,
          divId: "adobe-dc-view"
      });
  
      const previewFilePromise = adobeDCView.previewFile({
          content: { promise: Promise.resolve(this.base64ToArrayBuffer(pdfData)) },
          metaData: { fileName: this.order_group ? this.order_group.as400_log_number + '.pdf' : 'document.pdf' }
      }, viewOptions);
  
      previewFilePromise.then(adobeViewer => {
          adobeViewer.executeCommand('TOGGLE_COMMENTING', true);
      });
  
      if (that.allowEdit) {
          adobeDCView.registerCallback(
              AdobeDC.View.Enum.CallbackType.SAVE_API,
              function (metaData, content, options) {
                  // Save PDF edits
                  return new Promise((resolve, reject) => {
                      resolve({
                          code: AdobeDC.View.Enum.ApiResponseCode.SUCCESS,
                          data: {}
                      });
                  });
              }
          );
      }
  
      // Close the PDF viewer if an error occurs
      previewFilePromise.catch(error => {
          console.error('Error loading PDF:', error);
          this.showError('Error loading PDF. Please try again.'); // Display error message
          this.close(); // Close the PDF viewer
      });
  }
  ,
  
      base64ToArrayBuffer(base64) {
    try {
      const bin = window.atob(base64);
      const len = bin.length;
      const uInt8Array = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        uInt8Array[i] = bin.charCodeAt(i);
      }
      return uInt8Array.buffer;
    } catch (error) {
      console.error('Error decoding base64 string:', error);
      // Handle the error gracefully, such as displaying an error message to the user
      return null; // Or any other appropriate action
    }
  }
  
    }
  };
  </script>
  
  <style scoped lang="scss">
  .pdfWrapper {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 1);
    z-index: 10000;
  
    #adobe-dc-view {
      width: 100%;
      height: calc(100% - 100px);
    }
  }
  
  .in_pdf_order {
    width: 100%;
    position: relative;
    float: left;
    height: 700px;
  
    #adobe-dc-view {
      width: 100%;
      height: 100%;
    }
  }
  </style>
  